<template>
    <span :class="['text-xs font-medium leading-[1.2] text-theme-text', isActive && 'text-theme-accent']">
        <slot />
    </span>
</template>

<script>
/**
 * Label component for SettingsButton card variant.
 * Automatically inherits active state from parent SettingsButton via provide/inject.
 *
 * @example
 * <SettingsButton variant="card" :is-active="selected">
 *     <IconComponent />
 *     <SettingsButtonLabel>Label Text</SettingsButtonLabel>
 * </SettingsButton>
 */
export default {
    name: 'SettingsButtonLabel',
    inject: {
        settingsButtonActive: { default: () => ({ value: false }) },
    },
    computed: {
        isActive() {
            return this.settingsButtonActive?.value ?? false;
        },
    },
};
</script>
